module.exports = __webpack_public_path__ + "static/img/Lift.887c6be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/advertisingImagesNew/Lift.jpg
// module id = Mvla
// module chunks = 12